export const WELD_INTRODUCTORY_CALL_URL =
  "https://meetings.hubspot.com/chloe-randles/weld-introductory-call";

export const WELD_EXISTING_CUSTOMER_CALL_URL =
  "https://meetings.hubspot.com/ruxandra-elena/existing-customer-call";

export const WELD_CONTRACT_RENEWAL_CALL_URL =
  "https://meetings.hubspot.com/ruxandra-elena/renewal-call?uuid=3693ffef-50b1-4a92-b486-b2cf5afd9c80";
